import { Box, Stack } from "@mui/material";
import { useBiCommonDataContext } from "../../../contexts/BiCommonDataContext.ts";
import PartContainer from "../../viewer/common/PartContainer.tsx";
import PreviewActions from "../../viewer/common/PreviewActions.tsx";
import EditingHistoryControls from "../common/EditingHistoryControls.tsx";
import type { EditorProps } from "../../viewer/common/Types.ts";
import BuildProgressWrapper from "../BuildProgressWrapper";
import BuilderMoreAction from "../common/fields/BuilderMoreAction.tsx";
import useTrackMeasuresListUpdate from "./hooks/useTrackMeasuresListUpdate";
import EditPreviewComponent from "./preview/EditPreviewComponent";
import TileContainer from "./preview/TileContainer";
import TableComponent from "./table/TableComponent";

const TileEditor = ({ ReportTypeSelector }: EditorProps) => {
  useTrackMeasuresListUpdate();
  const { onRefreshGrid } = useBiCommonDataContext();

  return (
    <TileContainer>
      <Stack direction="row" sx={{ flex: 1 }}>
        <PartContainer
          sx={{ maxWidth: "24rem", minWidth: "24rem" }}
          caption={<Box sx={{ pl: "1.3rem" }}>Builder</Box>}
          actions={<BuilderMoreAction />}
        >
          <TableComponent ReportTypeSelector={ReportTypeSelector} />
        </PartContainer>
        <BuildProgressWrapper>
          <PartContainer
            sx={{ borderRight: "unset", p: "1.3rem", pt: 2 }}
            containerSx={{ position: "relative", gap: "1rem" }}
            caption="Preview"
            actions={<PreviewActions onRefresh={onRefreshGrid} EditingHistory={<EditingHistoryControls />} />}
          >
            <TileEditorContainer />
          </PartContainer>
        </BuildProgressWrapper>
      </Stack>
    </TileContainer>
  );
};

export default TileEditor;

const TileEditorContainer = () => {
  return <EditPreviewComponent />;
};
